import { callApiDangNhap, callApiDangNhapCaptcha } from "@/api/dang-nhap";
import {
  callApiSetCurrentDonVi,
  callApiGetDonViCurrentUser,
  callApiGetPermissions,
  callApiSearchCanBo,
  callApiSearchLoaiVanBan,
  callApiSearchLuong,
  callApiThemLuong,
  callApiXoaLuong,
  callApiChenLuong,
  callApiGetMultiCanBo,
  callApiGetAllSoDen,
  callApiGetAllSoDi,
  callApiGetAllSoDenTraCuu,
  callApiThemMoiFile,
  callApiThemMoiFileHoSo,
  callApiDownloadMultiFile,
  callApiDownloadFile,
  callApiDownloadFileQLVB,
  callApiAddQRCode,
  callApiPreviewFile,
  callApiGetCanBoIgnore,
  callApiGetCanBoVanThu,
  callApiGetFileInFolder,
  callApiGetThongTinNguoiDung,
  callApiUpdateThongTinNguoiDung,
  callApiUpdateAnhCaNhan,
  callApiUploadAnhCanBo,
  callApiUpdateAnhCanBo,
  callApiScanVanBan,
  callApiKyDienTu,
  callApiGetPhanHoiMoiNhat,
  callApiGetAccessTokenFromIoC,
  callApiGetImage,
  callApiSearchCanBoSoanThao,
  callApiChangeGenerateSetupCode,
  callApiConfirmUsing,
  callApiValidateLogin,
  callApiGetAppId, callApiGetAccessToken,
  callApGetTreeDonVi,
} from "@/api/common";
import {
  callApiSearchDonViNgoai,
  callApiGetMultiDonViNgoai,
  callApiGetDonViNgoaiIgnore,
} from "@/api/don-vi-ngoai";
import {
  callApiSearchDonViTrong,
  callApiGetMultiDonViTrong,
  callApiGetDonViTrongIgnore,
  callApiSearchDonViTrongDonViNgoai,
  callApiGetListPXLYKien,
} from "@/api/don-vi-trong";
import { callApiSearchDoKhan } from "@/api/do-khan";
import Vue from "vue";

const setIsLogin = (context, isLogin) => {
  context.commit("SET_IS_LOGIN", isLogin);
};

const login = (context, payload) => {
  return callApiDangNhap(payload);
};

const loginCaptcha = (context, payload) => {
  return callApiDangNhapCaptcha(payload);
};

const setCurrentDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSetCurrentDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDonViVaChucVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViCurrentUser(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_DON_VI_VA_CHUC_VU", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetPermissions(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_QUYEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const previewFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPreviewFile(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const setNhiemVuCaNhanTabIndex = (context, nhiemVuCaNhanTabIndex) => {
  context.commit("SET_NHIEM_VU_CA_NHAN_TAB_INDEX", nhiemVuCaNhanTabIndex);
};

const searchDonViNgoai = async ({ commit }, payload) => {
  const response = await callApiSearchDonViNgoai(payload);
  if (response && response.data.PageData) {
    commit("LAY_LIST_DON_VI_NGOAI_THANH_CONG", response.data.PageData);
    return response.data;
  }
};

const GetMultiDonViNgoai = async ({ commit }, payload) => {
  const response = await callApiGetMultiDonViNgoai(payload.data);
  if (response && response.data.IsSuccess) {
    commit("LAY_MULTI_DON_VI_NGOAI", response.data.Data);
  }
};

const searchDonViTrong = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchDonViTrong(payload)
      .then((response) => {
        if (response && response.data.IsSuccess) {
          commit("LAY_LIST_DON_VI_TRONG_THANH_CONG", response.data.Data);
        }
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const GetMultiDonViTrong = async ({ commit }, payload) => {
  const response = await callApiGetMultiDonViTrong(payload.data);
  if (response && response.data.IsSuccess) {
    commit("LAY_MULTI_DON_VI_TRONG", response.data.Data);
  }
};

const GetMultiCanBo = async ({ commit }, payload) => {
  const response = await callApiGetMultiCanBo(payload.data);
  if (response && response.data.IsSuccess) {
    commit("LAY_MULTI_CAN_BO", response.data.Data);
  }
};

const searchCanBo = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchCanBo(payload)
      .then((response) => {
        if (response && response.data.IsSuccess) {
          commit(
            "LAY_LIST_CAN_BO_TRONG_THANH_CONG",
            response.data.Data.PageData
          );
        }
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const searchCanBoSoanThao = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchCanBo(payload)
      .then((response) => {
        if (response && response.data.IsSuccess) {
          commit("LAY_LIST_CAN_BO_SOAN_THAO", response.data.Data.PageData);
        }
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const layDanhSachCanBo = async ({ commit }, payload) => {
  const response = await callApiGetCanBoIgnore(payload.data);
  if (response && response.data.IsSuccess) {
    commit("SET_DANH_SACH_CAN_BO", response.data.Data);
    payload.onSuccess && payload.onSuccess();
  }
};

const searchCanBoVanThu = async ({ commit }, payload) => {
  const response = await callApiGetCanBoVanThu(payload);
  if (response && response.data.IsSuccess) {
    commit("SET_DANH_SACH_CAN_BO_VAN_THU", response.data.Data.PageData);
  }
};

const searchLoaiVanBan = async ({ commit }, payload) => {
  const response = await callApiSearchLoaiVanBan(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_LIST_LOAI_VAN_BAN_THANH_CONG", response.data.Data.PageData);
    return response.data.Data.PageData;
  }
};

const searchDoKhan = async ({ commit }, payload) => {
  const response = await callApiSearchDoKhan(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_LIST_DO_KHAN_THANH_CONG", response.data.Data.PageData);
  }
};

const searchLuong = async ({ commit }, payload) => {
  const response = await callApiSearchLuong(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_LIST_LUONG_KY_DUYET_THANH_CONG", response.data.Data);
  }
};

const getAllSoDen = async ({ commit }, payload) => {
  const response = await callApiGetAllSoDen(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_ALL_SO_DEN_THANH_CONG", response.data.Data);
  }
  return response;
};

const getAllSoDi = async ({ commit }, payload) => {
  const response = await callApiGetAllSoDi(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_ALL_SO_DI_THANH_CONG", response.data.Data);
  }
  return response;
};

const getAllSoDenTraCuu = async ({ commit }, payload) => {
  const response = await callApiGetAllSoDenTraCuu(payload);
  if (response && response.data.IsSuccess) {
    commit("LAY_ALL_SO_DEN_TRA_CUU_THANH_CONG", response.data.Data);
  }
};

const getThongTinNguoiDung = async (context, payload) => {
  const response = await callApiGetThongTinNguoiDung(payload.data);
  if (response && response.data.IsSuccess) {
    context.commit("SET_THONG_TIN_USER", response.data.Data[0]);
    context.commit("LAY_MULTI_NGUOI_DUNG", response.data.Data);
    payload.onSuccess && payload.onSuccess(response.data.Data[0]);
  }
};

const getPhanHoiMoiNhat = async (context, payload) => {
  const response = await callApiGetPhanHoiMoiNhat(payload.data);
  if (response) {
    if (response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.message,
      });
    }
  } else {
    Vue.toasted.global.showErrorMessage({
      message: "Lỗi máy chủ",
    });
  }
};

const updateThongTinNguoiDung = async (context, payload) => {
  const response = await callApiUpdateThongTinNguoiDung(payload.data);
  if (response) {
    if (response.data.IsSuccess) {
      Vue.toasted.global.showSuccessMessage({
        message: "Cập nhật thành công",
      });
      payload.onSuccess && payload.onSuccess();
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.message,
      });
      payload.onFail && payload.onFail();
    }
  } else {
    Vue.toasted.global.showErrorMessage({
      message: "Lỗi máy chủ",
    });
  }
};

const themLuong = async (context, payload) => {
  const response = await callApiThemLuong(payload.data);
  if (response && response.data.IsSuccess) {
    Vue.toasted.global.showSuccessMessage({
      message: "Lưu luồng thành công",
    });
    payload.onSuccess && payload.onSuccess();
  } else {
    Vue.toasted.global.showErrorMessage({
      message: "Lưu luồng thất bại",
    });
    payload.onFailed && payload.onFailed(response.data.Messages[0]);
  }
};

const xoaLuong = async (context, payload) => {
  const response = await callApiXoaLuong(payload.data);
  if (response && response.data.IsSuccess) {
    Vue.toasted.global.showSuccessMessage({
      message: "Xóa luồng thành công",
    });
    payload.onSuccess && payload.onSuccess();
  }
};

const chenLuong = async (context, payload) => {
  const response = await callApiChenLuong(payload.data);
  if (response && response.data.IsSuccess) {
    Vue.toasted.global.showSuccessMessage({
      message: "Sửa luồng thành công",
    });
    payload.onSuccess && payload.onSuccess();
  } else {
    Vue.toasted.global.showErrorMessage({
      message: "Tên luồng này đã tồn tại",
    });
    payload.onFailed && payload.onFailed(response.data.Messages[0]);
  }
};

const themMoiFile = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiFile(payload)
      .then((response) => {
        if (!response.data.IsSuccess) {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: "Thao tác thất bại",
        });
        reject(error);
      });
  });
};

const DownloadMultiFile = (context, payload) => {
  return new Promise((resolve) => {
    callApiDownloadMultiFile(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: error,
        });
      });
  });
};

const themMoiFileHoSo = (context, payload) => {
  return new Promise((resolve) => {
    callApiThemMoiFileHoSo(payload)
      .then((response) => {
        if (!response.data.IsSuccess) {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: error,
        });
      });
  });
};

const updateAnhCaNhan = async (context, payload) => {
  const response = await callApiUpdateAnhCaNhan(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess();
    Vue.toasted.global.showSuccessMessage({
      message: `Cập nhật ${
        payload.data.Loai == 1 ? "ảnh đại diện" : "ảnh chữ ký"
      } thành công`,
    });
  } else {
    payload.onFail && payload.onFail();
    Vue.toasted.global.showErrorMessage({
      message: `Cập nhật ảnh thất bại`,
    });
  }
};

const uploadAnhTheoCanBo = async (context, payload) => {
  try {
    const response = await callApiUploadAnhCanBo(payload.data);
    if (response && response.data.succeeded) {
      payload.onSuccess && payload.onSuccess(response);
    } else {
      payload.onFail && payload.onFail(response);
      Vue.toasted.global.showErrorMessage({
        message: `Cập nhật ảnh thất bại`,
      });
    }
  } catch (e) {
    Vue.toasted.global.showErrorMessage({
      message: `Cập nhật ảnh thất bại`,
    });
  }
};

const updateAnhTheoCanBo = async (context, payload) => {
  const response = await callApiUpdateAnhCanBo(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess && payload.onSuccess(response);
    Vue.toasted.global.showSuccessMessage({
      message: `Cập nhật ảnh thành công`,
    });
  } else {
    payload.onFail && payload.onFail(response);
    Vue.toasted.global.showErrorMessage({
      message: `Cập nhật ảnh thất bại`,
    });
  }
};

const downloadFile = (context, payload) => {
  return callApiDownloadFile(payload);
};

const downloadFileQLVB = (context, payload) => {
  return callApiDownloadFileQLVB(payload);
};

const addQRCode = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddQRCode(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getFileInFolder = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetFileInFolder(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDonViTrongIgnore = async ({ commit }, payload) => {
  const response = await callApiGetDonViTrongIgnore(payload.data);
  if (response && response.data.IsSuccess) {
    commit("SET_DON_VI_TRONG_IGNORE", response.data.Data);
    payload.onSuccess && payload.onSuccess();
  }
};

const layDonViNgoaiIgnore = async ({ commit }, payload) => {
  const response = await callApiGetDonViNgoaiIgnore(payload.data);
  if (response && response.data) {
    commit("SET_DON_VI_NGOAI_IGNORE", response.data);
    payload.onSuccess && payload.onSuccess();
  }
};

const layDonViTrongNgoai = async ({ commit }, payload) => {
  const response = await callApiSearchDonViTrongDonViNgoai(payload);
  if (response && response.data.IsSuccess) {
    commit("SET_DON_VI_TRONG_NGOAI", response.data.Data);
  }
};

const layDanhSachPXLYKien = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetListPXLYKien(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const scanVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiScanVanBan(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const setScanStatus = (context, payload) => {
  context.commit("SET_SCAN_STATUS", payload);
};

const getAccessTokenFromIoC = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAccessTokenFromIoC(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getImage = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetImage(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachCotHienThi = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_HIEN_THI", payload);
};

const kyDienTu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiKyDienTu(payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const changeGenerateSetupCode = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChangeGenerateSetupCode(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
};

const confirmUsing = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfirmUsing(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
};

const validateLogin = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiValidateLogin(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
};

const getAppId = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAppId(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
};

const getAccessToken = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAccessToken(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const getTreeDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApGetTreeDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  changeGenerateSetupCode,
  confirmUsing,
  validateLogin,
  kyDienTu,
  themMoiFileHoSo,
  getFileInFolder,
  previewFile,
  layDonViNgoaiIgnore,
  layDonViTrongIgnore,
  addQRCode,
  downloadFile,
  downloadFileQLVB,
  login,
  loginCaptcha,
  setIsLogin,
  setCurrentDonVi,
  layDanhSachDonViVaChucVu,
  layDanhSachQuyen,
  setNhiemVuCaNhanTabIndex,
  searchDonViNgoai,
  searchDonViTrong,
  searchCanBo,
  searchLoaiVanBan,
  searchDoKhan,
  searchLuong,
  themLuong,
  xoaLuong,
  chenLuong,
  GetMultiDonViTrong,
  GetMultiDonViNgoai,
  GetMultiCanBo,
  getAllSoDen,
  getAllSoDenTraCuu,
  themMoiFile,
  DownloadMultiFile,
  layDanhSachCanBo,
  searchCanBoVanThu,
  layDonViTrongNgoai,
  layDanhSachPXLYKien,
  getThongTinNguoiDung,
  updateThongTinNguoiDung,
  updateAnhCaNhan,
  uploadAnhTheoCanBo,
  updateAnhTheoCanBo,
  scanVanBan,
  getPhanHoiMoiNhat,
  setScanStatus,
  getAccessTokenFromIoC,
  getDanhSachCotHienThi,
  searchCanBoSoanThao,
  getAllSoDi,
  getImage,
  getAppId,
  getAccessToken,
  getTreeDonVi,
};
